import { render, staticRenderFns } from "./PriceCalculationItemEdit.vue?vue&type=template&id=16cfdd36&scoped=true&"
import script from "./PriceCalculationItemEdit.vue?vue&type=script&lang=js&"
export * from "./PriceCalculationItemEdit.vue?vue&type=script&lang=js&"
import style0 from "./PriceCalculationItemEdit.vue?vue&type=style&index=0&id=16cfdd36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cfdd36",
  null
  
)

export default component.exports